// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_home-container__RpESO {
  background-color: #fff;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.styles_home-logo__puioq {
  border: 1px solid #707070;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 48px;
}

.styles_form-item-label__WMxeR {
  color: var(--primary-color);
  font-weight: 400;
  font-size: 16px;
}

.styles_form-item__FwVBF textarea {
  border-bottom: 1px solid #000000;
  border-radius: 0px;
}

.styles_form-item__FwVBF textarea:hover,
.styles_form-item__FwVBF textarea:focus {
  border-bottom: 1px solid #000000;
}

.styles_form-item--title__tqohw {
  width: 75%;
}

.styles_form-item--description__jFiyb {
  width: 50%;
}

.styles_form-item--title__tqohw textarea {
  font-weight: 700;
  font-size: 32px;
  margin-bottom: 32px;
  text-align: center;
}

.styles_form-item--description__jFiyb textarea {
  font-weight: 400;
  font-size: 20px;
  text-align: center;
}

.styles_form-item--link__qEqLA{
  margin-top: 48px;
}

.styles_form-item-row__Mcznd{
  display: flex;
  align-items: flex-end;
  gap: 20px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/surveys-thanks/styles/styles.module.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACI,gBAAgB;AACpB;;AAEA;EACI,aAAa;EACb,qBAAqB;EACrB,SAAS;AACb","sourcesContent":[".home-container {\n  background-color: #fff;\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: column;\n}\n\n.home-logo {\n  border: 1px solid #707070;\n  border-radius: 8px;\n  padding: 16px;\n  margin-bottom: 48px;\n}\n\n.form-item-label {\n  color: var(--primary-color);\n  font-weight: 400;\n  font-size: 16px;\n}\n\n.form-item textarea {\n  border-bottom: 1px solid #000000;\n  border-radius: 0px;\n}\n\n.form-item textarea:hover,\n.form-item textarea:focus {\n  border-bottom: 1px solid #000000;\n}\n\n.form-item--title {\n  width: 75%;\n}\n\n.form-item--description {\n  width: 50%;\n}\n\n.form-item--title textarea {\n  font-weight: 700;\n  font-size: 32px;\n  margin-bottom: 32px;\n  text-align: center;\n}\n\n.form-item--description textarea {\n  font-weight: 400;\n  font-size: 20px;\n  text-align: center;\n}\n\n.form-item--link{\n    margin-top: 48px;\n}\n\n.form-item-row{\n    display: flex;\n    align-items: flex-end;\n    gap: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"home-container": `styles_home-container__RpESO`,
	"home-logo": `styles_home-logo__puioq`,
	"form-item-label": `styles_form-item-label__WMxeR`,
	"form-item": `styles_form-item__FwVBF`,
	"form-item--title": `styles_form-item--title__tqohw`,
	"form-item--description": `styles_form-item--description__jFiyb`,
	"form-item--link": `styles_form-item--link__qEqLA`,
	"form-item-row": `styles_form-item-row__Mcznd`
};
export default ___CSS_LOADER_EXPORT___;
